import { ColumnInformation } from '../../../types'

export const getTableElement = (tableId: string) => {
    const element = document.querySelector(`#${tableId}`)
    if (!element) {
        console.warn(`getTableElement: Could not find table with id "${tableId}"`)
        return null
    }

    return element
}

const getWidthFromElement = (element: Element) => parseInt(getComputedStyle(element).width)

/**
 * Get a list of widths pertaining to the relevant sticky header cells.
 * Used to calculate left and right positioning of table cells
 */
export const getColumnWidths = (tableId: string): ColumnInformation[] | undefined => {
    const table = getTableElement(tableId)
    if (!table) return

    let colInfo: ColumnInformation[] = []

    table.querySelectorAll('.table-header-cell--sticky-left').forEach((element) => {
        colInfo.push({
            position: 'left',
            width: getWidthFromElement(element),
        })
    })

    table.querySelectorAll('.table-header-cell--sticky-right').forEach((element) => {
        colInfo.push({
            position: 'right',
            width: getWidthFromElement(element),
        })
    })

    return colInfo
}
